import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import { Switch, Route, Link } from 'react-router-dom'
import moment from 'moment'
import Select from 'react-select';
import 'react-select/dist/react-select.css';


// if (!window.Promise) {
//   window.Promise = Promise;
// }
class SummaryVehicle extends Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps){
  }
  render(){
    var upgradesHTML = []
    var upgradesAmount = (this.props.upgrades.reduce((upgrades_total, upgrade) => upgrade.amount + upgrades_total, 0) / 100)
    this.props.upgrades.forEach(function(upgrade, index) {
      upgradesHTML.push(<div key={index} className="row"><div className="twoColumn"><div className="threeQuarterDiv"><h6>{upgrade.display_title}</h6></div><div className="textAlignRight2"><h6>${((upgrade.amount)/100).toFixed(2)}</h6></div></div></div>)
    })

    var packageAmount = 0
    if(this.props.service){
        packageAmount = this.props.service.amount/100
    }
      return (
        <div>
          <div className="card-title">
              <div className="card-subtitle blue-background text-white text-center">
                <h5>{this.props.vehicle.year} {this.props.vehicle.make} {this.props.vehicle.model}</h5>
              </div>
            </div>
            <div className="card-title">
              <div className="card-title bg-white">
              <div className="row align-items-center">
                <div className="col ml-3 vehicleDiv">
                  <div className="row">
                    <div className="twoColumn">
                      <div className="threeQuarterDiv"><h6>{this.props.service.display_title}</h6></div>
                      <div className="textAlignRight2"><h6>${(this.props.service.amount/100).toFixed(2)}</h6></div>
                    </div>
                    {upgradesHTML}
                  </div>
                  <div className="row">
                  <div className="twoColumn">
                    <div className="threeQuarterDiv"><h6><b>Total:</b></h6></div><div className="textAlignRight2"><h6><b>${(packageAmount + upgradesAmount).toFixed(2)}</b></h6></div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
              )
    }
}
export default SummaryVehicle;



// WEBPACK FOOTER //
// ./src/Components/SummaryVehicle.js